<template>
  <v-flex xs12 class="event">
    <!-- Top-right “Edit” button -->
    <div class="layout justify-end p-0 mr-4" v-if="editableEvents.includes(ev.type) || deletableEvents.includes(ev.type)">
      <v-menu bottom left offset-y>
        <template v-slot:activator="{ on }">
          <v-btn icon small v-on="on">
            <v-icon>more_vert</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-tile v-if="editableEvents.includes(ev.type) && ev.status == 1" @click="$emit('open-edit')">
            <v-list-tile-title>
                      {{ $t('edit') || 'Edita' }}
            </v-list-tile-title>
          </v-list-tile>

          <v-list-tile v-if="deletableEvents.includes(ev.type) && ev.status == 1" @click="$emit('open-delete')">
            <v-list-tile-title>
                      {{ $t('delete') || 'Eliminar' }}
            </v-list-tile-title>
          </v-list-tile>

          <v-list-tile v-if="ev.status != 1" @click="$emit('open-restore')">
            <v-list-tile-title>
                      {{ $t('recover') || 'Recuperar' }}
            </v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </div>

    <v-container>
      <v-layout row wrap>
        <v-flex xs12 md12 class="item">
          <div class="label">
            {{ getTypeName(ev.type) | checkParam }}
          </div>
        </v-flex>
        <v-flex xs6 md4 class="item">
          <v-text-field
            :label="'Estat'"
            :value="ev.status == 1 ? 'Actiu' : 'Eliminat'"
            @change="v => (match.streaming = v)"
            :disabled="true"
          ></v-text-field>
        </v-flex>
        <v-flex xs6 md4 class="item">
          <v-text-field
            :label="'Tipus'"
            :value="getTypeName(ev.type) | checkParam"
            @change="v => (match.streaming = v)"
            :disabled="true"
          ></v-text-field>
        </v-flex>
        <v-flex xs6 md4 class="item">
          <v-text-field
            :label="'Hora'"
            :value="formatDate(ev.date * 1000) | checkParam"
            @change="v => (match.streaming = v)"
            :disabled="true"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md12 class="item" v-if="ev.type == 'comment'">
          <v-textarea
            auto-grow
            rows="1"
            :label="'Descripció'"
            :value="ev.data.description"
            @change="v => (match.streaming = v)"
            :disabled="true"
          ></v-textarea>
        </v-flex>
        <template v-if="team">
          <v-flex xs6 md4 class="item">
            <v-text-field
              :label="'Minut'"
              :value="ev.data.time"
              @change="v => (match.streaming = v)"
              :disabled="true"
            ></v-text-field>
          </v-flex>
          <v-flex xs6 md4 class="item">
            <v-text-field
              :label="'Equip'"
              :value="team.name"
              @change="v => (match.streaming = v)"
              :disabled="true"
            ></v-text-field>
          </v-flex>

          <v-flex
            xs6
            md4
            class="item"
            v-if="['goal', 'autogoal', 'penalty'].includes(ev.type)"
          >
            <v-text-field
              :label="'Resultat actual'"
              :value="ev.current_result"
              @change="v => (match.streaming = v)"
              :disabled="true"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md12 class="item" v-if="playerEvents.includes(ev.type)">
            <v-textarea
              auto-grow
              rows="1"
              :label="'Descripció'"
              :value="ev.data.description"
              @change="v => (match.streaming = v)"
              :disabled="true"
            ></v-textarea>
          </v-flex>
        </template>

        <template v-if="['redcard'].includes(ev.type)">
          <v-flex xs6 md6 class="item">
            <v-textarea
              auto-grow
              rows="1"
              :label="'Observacions'"
              :value="ev.data.comment"
              @change="v => (match.streaming = v)"
              :disabled="true"
            ></v-textarea>
          </v-flex>
          <v-flex xs6 md6 class="item">
            <v-textarea
              auto-grow
              rows="1"
              :label="'Sanció'"
              v-if="ev.data.subtype"
              :value="
                ev.data.subtype +
                  ' ' +
                  $t(punishments[ev.data.subtype].description)
              "
              @change="v => (match.streaming = v)"
              :disabled="true"
            ></v-textarea>
          </v-flex>
        </template>

        <template v-if="['closed'].includes(ev.type)">
          <v-flex xs12 md12 class="item">
            <v-textarea
              auto-grow
              rows="1"
              :label="'Observacions'"
              :value="ev.data.observations"
              @change="v => (match.streaming = v)"
              :disabled="true"
            ></v-textarea>
          </v-flex>
          <v-flex xs3 md3 class="item" @click="openPhoto(ev.data.local_image)">
            <span>{{ $t("miccamps.match_actions.photo_local_team") }}</span>
            <v-img
              class="img"
              v-if="ev.data.local_image"
              :src="ev.data.local_image"
            ></v-img>
          </v-flex>
          <v-flex xs3 md3 class="item" @click="openPhoto(ev.data.away_image)">
            <span>{{ $t("miccamps.match_actions.photo_away_team") }}</span>
            <v-img
              class="img"
              v-if="ev.data.away_image"
              :src="ev.data.away_image"
            ></v-img>
          </v-flex>
          <v-flex xs3 md3 class="item" @click="openPhoto(ev.data.act_image)">
            <span>{{ $t("miccamps.match_actions.photo_match") }}</span>
            <v-img
              class="img"
              v-if="ev.data.act_image"
              :src="ev.data.act_image"
            ></v-img>
          </v-flex>
        </template>
        <template v-if="['ready'].includes(ev.type)">
          <v-flex xs12 md12 class="item">
            <v-textarea
              auto-grow
              rows="1"
              :label="'Alineacions'"
              :value="''"
              @change="v => (match.streaming = v)"
              :disabled="true"
            ></v-textarea>
          </v-flex>
          <v-flex xs3 md3 class="item" @click="openPhoto(ev.data.local_image)">
            <span>{{ $t("miccamps.match_actions.photo_local_team") }}</span>
            <v-img
              class="img"
              v-if="ev.data.local_image"
              :src="ev.data.local_image"
            ></v-img>
          </v-flex>
          <v-flex xs3 md3 class="item" @click="openPhoto(ev.data.away_image)">
            <span>{{ $t("miccamps.match_actions.photo_away_team") }}</span>
            <v-img
              class="img"
              v-if="ev.data.away_image"
              :src="ev.data.away_image"
            ></v-img>
          </v-flex>
          <v-flex xs3 md3 class="item" @click="openPhoto(ev.data.act_image)">
            <span>{{ $t("miccamps.match_actions.photo_match") }}</span>
            <v-img
              class="img"
              v-if="ev.data.act_image"
              :src="ev.data.act_image"
            ></v-img>
          </v-flex>
        </template>
      </v-layout>
    </v-container>

    <edit-event-dialog
      :value="showEditDialog"
      :event="ev"
      :team="team"
      :match-teams="matchTeams"
      :loading="isEditingEvent"
      :player-events="playerEvents"
      @confirm="onEditEventConfirm"
      @input="$emit('close-dialogs')"
    />
    <delete-event-dialog
      :value="showDeleteDialog"
      :event="ev"
      :team="team"
      :loading="isEditingEvent"
      @confirm="onDeleteEventConfirm"
      @input="$emit('close-dialogs')"
    />
    <restore-event-dialog
      :value="showRestoreDialog"
      :event="ev"
      :team="team"
      :loading="isEditingEvent"
      @confirm="onRestoreEventConfirm"
      @input="$emit('close-dialogs')"
    />
  </v-flex>
</template>

<script>
/* global moment */
import i18n from '@/i18n'
import EditEventDialog from './EditEventDialog.vue'
import DeleteEventDialog from './DeleteEventDialog.vue'
import RestoreEventDialog from './RestoreEventDialog.vue'

export default {
  name: 'MatchEvent',
  props: {
    event: {
      type: Object,
      required: true
    },
    team: {
      type: Object,
      required: false
    },
    matchTeams: {
      type: Object,
      required: false
    },
    localTeam: {
      type: Object,
      required: false
    },
    currentResult: {
      type: [String, Number],
      required: false
    },
    isEditingEvent: {
      type: Boolean,
      required: false
    },
    showEditDialog: { type: Boolean, default: false },
    showDeleteDialog: { type: Boolean, default: false },
    showRestoreDialog: { type: Boolean, default: false }

  },
  components: {
    EditEventDialog,
    DeleteEventDialog,
    RestoreEventDialog
  },
  data: function () {
    return {
      ev: false,
      editableEvents: [
        'goal',
        'autogoal',
        'yellowcard',
        'redcard',
        'injury',
        'changein',
        'changeout',
        'corner',
        'offside',
        'ready'
      ],
      deletableEvents: [
        'goal',
        'corner',
        'changein',
        'changeout',
        'offside',
        'autogoal',
        'penalty',
        'yellowcard',
        'redcard',
        'penaltyfail',
        'injury',
        'comment',
        'penalties'
      ]
    }
  },
  created () {
    this.ev = Object.assign({}, this.event)
    this.ev.data = JSON.parse(this.ev.data)
  },
  computed: {
    playerEvents () {
      return [
        'goal',
        'autogoal',
        'yellowcard',
        'redcard',
        'injury',
        'changein',
        'changeout',
        'penalty',
        'fail',
        'success'
      ]
    },

    punishments () {
      var punishments = this.$store.getters['competition/getPunishments'](
        this.$store.getters['events/getCurrentEvent']().type_id
      )
      var oPunishments = {}
      punishments.forEach(punish => {
        oPunishments[punish.code] = punish
      })

      return oPunishments
    }
  },
  methods: {
    formatDate (date) {
      return moment(date).format('HH:mm DD/MM/YYYY')
    },

    getTypeName (type) {
      var name = ''
      switch (type) {
        case 'uniforms':
          name = 'miccamps.status.uniforms'
          break
        case 'ready':
          name = 'miccamps.status.players'
          break
        case 'start1':
          name = 'miccamps.match_actions.start1'
          break
        case 'stop1':
          name = 'miccamps.match_actions.stop1'
          break
        case 'start2':
          name = 'miccamps.match_actions.start2'
          break
        case 'stop2':
          name = 'miccamps.match_actions.stop2'
          break
        case 'penalties':
          name = 'miccamps.status.penalties'
          break
        case 'end':
          name = 'miccamps.status.end'
          break
        case 'closed':
          name = 'miccamps.status.closed'
          break
        case 'corner':
          name = 'miccamps.match_actions.corner'
          break
        case 'offside':
          name = 'miccamps.match_actions.offside'
          break
        case 'goal':
          name = 'miccamps.match_actions.goal'
          break
        case 'autogoal':
          name = 'miccamps.match_actions.autogoal'
          break
        case 'yellowcard':
          name = 'miccamps.match_actions.yellowcard'
          break
        case 'redcard':
          name = 'miccamps.match_actions.redcard'
          break
        case 'injury':
          name = 'miccamps.match_actions.injury'
          break
        case 'penalty':
          name = 'miccamps.match_actions.penalty'
          break
        case 'fail':
          name = 'miccamps.match_actions.fail'
          break
        case 'success':
          name = 'miccamps.match_actions.success'
          break
        case 'changein':
          name = 'miccamps.match_actions.change'
          break
        case 'changeout':
          name = 'miccamps.match_actions.change'
          break
        case 'comment':
          name = 'miccamps.match_actions.comment'
          break
        default:
          name = type
      }

      return i18n.t(name)
    },

    openPhoto (url) {
      window.open(url)
    },

    onEditEventConfirm (updatedEvent) {
      this.$emit('edit-event', updatedEvent)
    },

    onDeleteEventConfirm () {
      this.$emit('delete-event', this.ev)
    },

    onRestoreEventConfirm () {
      this.$emit('restore-event', this.ev)
    }
  }
}
</script>

<style lang="scss" scoped>
.event {
  margin: 0px;
  padding-top: 20px;
  background-color: #efefef;
  border-radius: 4px;
  border-left: 3px solid $dark-color;

  .container {
    width: 100% !important;
    margin: 0 auto;

    .v-image {
      width: 100% !important;
      height: auto;
      margin: 0 auto;
    }

    .item {
      .label {
        position: relative;
        border-radius: 4px;
        // top: -20px;
        margin-bottom: 20px;
        font-weight: bold;
        text-transform: uppercase;
        background-color: #fff;
        width: fit-content;
        padding: 10px 15px;
        padding-left: 40px;
        left: -20px;
        margin-top: -10px;
      }

      .v-textarea textarea {
        border: 0 !important;
      }

      .img {
        cursor: pointer;
        margin-bottom: 10px;
      }
    }
  }
}
</style>
<style lang="scss">
.event {
  .theme--light.v-input--is-disabled .v-label,
  .theme--light.v-input--is-disabled input,
  .theme--light.v-input--is-disabled textarea {
    color: #000 !important;
  }
}
</style>
